import { Component, ElementRef, ViewChild, OnInit, EventEmitter, Output, NgZone, Input, SimpleChanges } from '@angular/core';
import { MapsService } from '../../services/maps.service';
import { MapsAPILoader } from '@agm/core';
import { AssetService } from '../../services/asset.service'

declare var google: any

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {

  @Input('latitude') latitudeData
  @Input('longitude') longitudeData
  @Input('isEdit') isEdit
  @Input('selectedIndex') selectedIndex
  @Input('locationAdd') addLocation
  @Input('jobMap') mapJob
  @Output() public currentLocation = new EventEmitter<any>();
  latitude: number
  longitude: number
  address
  zoom
  geoCoder
  isMapEdit: boolean
  isFirstForm
  isView: boolean = true
  @ViewChild('search', { static: false }) public searchElementRef: ElementRef;

  constructor(
    private _mapsService: MapsService,
    private ngZone: NgZone,
    private mapsAPILoader: MapsAPILoader,
    public assetService: AssetService) {
    // this.mapsAPILoader.load().then(() => {
    //   this.geoCoder = new google.maps.Geocoder;
    //   console.log("hello here constor call and work....",this.geoCoder)
    // })


    this.assetService.formDataAsObservable().subscribe((data) => {
      console.log("data of form data ", data.data);
      if (data.data && !data.data.length) {
        this.isMapEdit = false
        this.setCurrentLocation('test1')
      }
    })
  }

  ngOnInit() {
    console.log('here check Is Edit.....', this.isMapEdit)
    // this.getDistance()
    // this.setCurrentLocation() 
    if (!this.mapJob) {
      this.loadMap()
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("CHANGES Map Component", changes);

    if (changes.isEdit && changes.isEdit.currentValue == true) {
      this.isMapEdit = true
      console.log('run...')

    }

    if (changes.latitudeData && changes.latitudeData.currentValue && changes.longitudeData && changes.longitudeData.currentValue) {
      console.log("run..latitude")
      this.latitude = changes.latitudeData.currentValue
      this.longitude = changes.longitudeData.currentValue
    }

    if (changes.isEdit && changes.isEdit.currentValue == false) {
      console.log('run...else')
      this.setCurrentLocation('test2')
      this.isMapEdit = false
    }
    if (changes.selectedIndex && changes.selectedIndex.currentValue == 0) {
      console.log('run...first')
      // this.setCurrentLocation()
      this.isFirstForm = changes.selectedIndex.currentValue
      // this.isMapEdit=false
    }
    if (changes.addLocation && changes.addLocation.currentValue) this.setCurrentLocation('test3')
    if (changes.mapJob && (changes.mapJob.currentValue || !changes.mapJob.currentValue)) {
      this.isView = changes.mapJob.currentValue
      if(this.isView) this.loadMap()
    } 

    console.log("VALUUE OF VIEW", this.isView);


  }


  loadMap() {
    console.log("VALUE OF MAP",typeof  this.isView , this.isView)
    if (this.isView) {


      this.mapsAPILoader.load().then(() => {
        let autocomplete = new google.maps.places.Autocomplete(
          this.searchElementRef.nativeElement,
          {
            types: ['address'],
          }
        );
        autocomplete.addListener('place_changed', () => {
          this.ngZone.run(() => {
            //get the place result
            let place: google.maps.places.PlaceResult = autocomplete.getPlace();

            //verify result
            if (place.geometry === undefined || place.geometry === null) {
              return;
            }

            //set latitude, longitude and zoom
            this.latitude = place.geometry.location.lat();
            this.longitude = place.geometry.location.lng();
            this.address = place.formatted_address
            this.zoom = 12;
            let data = {
              latitude: this.latitude,
              longitude: this.longitude,
              address: this.address
            }
            this.currentLocation.emit(data);
          });
        });
      });
    }
  }



  public getDistance() {
    this.mapsAPILoader.load().then(() => {
      console.log("CALL THIS FUNCTION OR NOT FOR DISTANCE");
      // let geoCoder = new google.maps.Geocoder;
      let distanceCoder = new google.maps.DistanceMatrixService
      const origin1 = { lat: 55.93, lng: -3.118 };
      const origin2 = "Greenwich, England";
      const destinationA = "Stockholm, Sweden";
      const destinationB = { lat: 50.087, lng: 14.421 };
      let origin44 = new google.maps.LatLng(Number(22.3039), Number(70.8022), true)
      let origin45 = new google.maps.LatLng(Number(22.3072), Number(73.1812))
      distanceCoder.getDistanceMatrix({
        // origins: [origin1, origin2],
        // let origin = new google.maps.LatLng(22.3039,70.8022, true)
        // origins: [new google.maps.LatLng(22.3039, 70.8022, true)],
        origins: [origin44],
        // destinations: [destinationA, destinationB],
        // destinations: [new google.maps.LatLng(23.0225, 72.5714, true)],
        destinations: [origin45],
        travelMode: google.maps.TravelMode.DRIVING,
        unitSystem: google.maps.UnitSystem.METRIC,
        // transitOptions: TransitOptions,
        // drivingOptions: DrivingOptions,
        // unitSystem: UnitSystem,
        avoidHighways: false,
        avoidTolls: false,
      }, (response, status) => {
        console.log("THIS IS VERY IMPORTANT DATA TO BE CALLED", response, status);
      })
    }).catch((error) => {
      console.log("ERROR WHILE LOAD GOOGLE MAP", error)
    })
  }

  private setCurrentLocation(test) {
    console.log("Where to call", test);
    // this._mapsService.getDistance()
    this._mapsService.setCurrentLocation().subscribe((data) => {
      this.latitude = data.latitude;
      this.longitude = data.longitude;
      this.address = data.address
      console.log("hello here is the current data..", data)

      this.currentLocation.emit(data);
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);

      autocomplete.addListener("place_changed", () => {

        this.ngZone.run(() => {

          let place: google.maps.places.PlaceResult = autocomplete.getPlace();


          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          console.log("not returned ------------------")
          console.log('PLACE------------->', place)
          this.latitude = place.geometry.location.lat();
          console.log("this.latitude", this.latitude)
          this.longitude = place.geometry.location.lng();
          console.log("this.longitude", this.longitude)
          this.address = place.formatted_address
          this.zoom = 12;
          let data = {
            latitude: this.latitude,
            longitude: this.longitude,
            address: this.address
          }
          this.currentLocation.emit(data);
        });

      });
    })
  }

  mapReady() {
  }



  markerDragEnd(event) {
    console.log('mark drag event check', event);
    this._mapsService.markerDragEnd(event).subscribe((data) => {
      console.log("data------->", data);
      this.latitude = data.latitude;
      this.longitude = data.longitude;
      this.address = data.address
      this.currentLocation.emit(data);
    });

  }


}
